import ConfigService from 'shared/services/config.service';

export const getOriginFacilityMapping = (): { [key: string]: string } =>
  JSON.parse(ConfigService.getConfigValue('Settings', 'OriginFacilityMapping') || '{}');
